import { Rating } from 'primereact/rating';
import { useEffect, useState } from 'react';
import { Controller, useWatch } from 'react-hook-form'

export function EnergyRating({
    control,name,wrapperClass,tooltip='',stars=5,disabled=false
}) {
  
    // 定義顏色對應，避免每次計算顏色
     let colorMapping = {
        1: '#22a209',
        2: '#22a209',
        3: '#E8AB43',
        4: '#F35252',
        5: '#F35252'
    };

    if(stars===3){
        colorMapping = {
        3: '#22a209',
        2: '#E8AB43',
        1: '#F35252'
        }
    }

    const watchedValue = useWatch({
        control,
        name,
        defaultValue: 0
    });

    // 顏色對應邏輯簡化
    const activeColor = colorMapping[watchedValue] || '#D9D9D9';
    
    return (
        <div className={wrapperClass}>
            <Controller
                name={name}
                control={control}
                defaultValue={0}
                render={({ field }) => (
                    <Rating
                        tooltip={tooltip}
                        tooltipOptions={{ position: 'top' }}
                        id={name}
                        value={field.value}
                        onChange={(e) => {
                            const newValue = e.value;
                            field.onChange(newValue);
                        }}
                        stars={stars}
                        // cancel={false}
                        disabled={disabled}
                        className='energy-bar'
                        offIcon={
                            <svg width="42" height="23" viewBox="0 0 42 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="42" height="23" fill="#D9D9D9" />
                            </svg>
                        }
                        onIcon={
                            <svg width="42" height="23" viewBox="0 0 42 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="42" height="23" fill={activeColor} />
                            </svg>
                        }
                        cancelIcon="pi pi-eraser"
                    />
                )}
            />
        </div>
    )
}